module.exports = __webpack_public_path__ + "static/media/LTC.6046cca1.svg";